<template>
  <div class="whyPartnery-body">
    <div class="title-box">Why Partner with Wecobi?</div>
    <div class="text-box-wrapper">
      <TextBoxGroup :textBoxes="firstGroup" />
      <TextBoxGroup :textBoxes="secondGroup" />
    </div>
  </div>
</template>

<script>
import TextBoxGroup from "../SharedComponents/TextBoxGroup.vue";

export default {
  name: "WhyPartner",
  components: {
    TextBoxGroup,
  },
  data() {
    return {
      firstGroup: [
        {
          title: "Sustainability First",
          text: "We prioritize environmental stewardship by helping brands reduce deadstock and avoid the environmental impacts of overproduction and waste.",
        },
        {
          title: "Boost Your Brand's Reach",
          text: "Leverage Wecobi’s growing community of conscious consumers who are ready to engage with your products and help extend their lifecycle.",
        },
      ],
      secondGroup: [
        {
          title: "Profit with Purpose",
          text: "Transform unsold goods into valuable marketing and revenue opportunities, all while maintaining your brand’s integrity and prestige.",
        },
        {
          title: "Full Support",
          text: "Our dedicated team offers onboarding assistance, technical support, and marketing insights to help you get the most from the platform.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.whyPartnery-body {
  width: 100%;
  height: fit-content;
  padding: 70px 60px;
  box-sizing: border-box;
}

.title-box {
  width: 100%;
  font-size: 27px;
  font-weight: 400;
  line-height: 1.2;
  color: #ff6d0a;
  border-bottom: 2px solid #ff6d0a;
  padding-bottom: 7px;
}

.text-box-wrapper {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

@media (max-width: 744px) {
  .whyPartnery-body {
    padding: 60px 40px;
  }
}

@media (max-width: 588px) {
  .whyPartnery-body {
    padding: 60px 30px;
  }
}

@media (max-width: 431px) {
  .text-box-wrapper {
    padding-top: 30px;
    gap: 30px;
  }
}
</style>
